import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import styled from "styled-components";
import StoreController, {
  CurrentOrderType,
  ProductType,
} from "../../controller/StoreController";
import { orderDetailRealmType } from "../../recoil/cart";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import { searchSimilarData } from "../../util/util";
import { ChatType } from "./Recorder";
import Spinner from "./Spinner";
import { PositionContextType } from "../../controller/UserController";

interface VoiceChatProps {
  chat: ChatType | null;
  setChat: (chat: ChatType | null) => void;
  recognizerMode: boolean;
  setRecognizerMode: (recognizerMode: boolean) => void;
  setIsChat: (isChat: boolean) => void;
  chatData: any;
  setChatData: (chatData: any) => void;
  setPlayIndex: (playIndex: number) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

const chatSamples = [
  "이벤트 매장 추천해줘",
  "카페 추천해줘",
  "오늘의 날씨는 뭐야?",
  "아메리카노 마시고 싶어",
  "반포식스",
  "1번째",
  "2번째",
  "3번째",
  "54123번째",
  "아메리카노",
  "바닐라",
  "초코",
  "집에 보내줘",
  "지유가오카",
  "비하인드",
  "시로이 케이크",
];

const getRandomChat = () => {
  const randomIndex = Math.floor(Math.random() * chatSamples.length);
  return chatSamples[randomIndex];
};

const VoiceChat = ({
  chat,
  setChat,
  recognizerMode,
  setRecognizerMode,
  setIsChat,
  chatData,
  setChatData,
  setPlayIndex,
  isLoading,
  setIsLoading,
}: VoiceChatProps) => {
  const navigate = useNavigate();
  const { position } = useOutletContext<PositionContextType>();
  const iframeRef = useRef<any>(null);

  const [chatType, setChatType] = useState<string>("init");
  const [selectedStore, setSelectedStore] = useState<any>(null);
  // const [isPay, setIsPay] = useState<boolean>(false);

  // api 호출
  const getStoreInfo = async () => {
    try {
      const oParams = {
        store_id: selectedStore.store_id,
      };
      const oRes = await StoreController.getMenu(oParams);

      if (oRes && oRes.data) {
        console.log("getMenu", oRes.data);
        const chatTemp = {
          content: `대표 메뉴입니다. 메뉴를 선택하세요.`,
          type: "bot",
          data: {
            menu_list: oRes.data.content.main.data,
          },
          state: "normal",
        };
        setChat(chatTemp);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const getAIResponse = async () => {
    try {
      if (chat !== null && chat.type === "user") {
        setIsLoading(true);

        const oParams: any = {
          longitude: position.lng,
          latitude: position.lat,
          limit: 10,
          radius: 2,
          request: chat.content,
          thread: "",
        };
        // if (isPay) oParams.type = "payment";
        const oRes = await StoreController.aiStoreRecommend(oParams);

        if (oRes && oRes.data) {
          console.log("AIStoreTest", oRes.data);

          // if (isPay && oRes.data.data.response_code === "payment") {
          //   if (oRes.data.data.response === "true") {
          //     if (iframeRef.current) {
          //       const data = {
          //         type: "payment",
          //         data: oRes.data.data.response,
          //       };
          //       iframeRef.current.contentWindow.postMessage(data, "*");
          //     }
          //   }
          // } else
          if (oRes.data.data.response.length > 0) {
            if (oRes.data.data.response_code === "event") {
              setPlayIndex(0);
              const chatTemp = {
                content: `추천 매장입니다. 매장을 선택하세요.`,
                type: "bot",
                data: {
                  store_list: oRes.data.data.response,
                },
                state: "normal",
              };
              setChatType("normal");
              // setIsPay(false);
              setChat(chatTemp);
            } else if (oRes.data.data.response_code === "store") {
              setPlayIndex(0);
              const chatTemp = {
                content: `추천 매장입니다. 매장을 선택하세요.`,
                type: "bot",
                data: {
                  store_list: oRes.data.data.response,
                },
                state: "normal",
              };
              setChatType("normal");
              // setIsPay(false);
              setChat(chatTemp);
            } else if (oRes.data.data.response_code === "menu") {
              setPlayIndex(0);
              const chatTemp = {
                content: `대표 메뉴입니다. 메뉴를 선택하세요.`,
                type: "bot",
                data: {
                  menu_list: oRes.data.data.response,
                },
                state: "normal",
              };
              setChatType("normal");
              // setIsPay(false);
              setChat(chatTemp);
            } else if (oRes.data.data.response_code === "ordered") {
              setPlayIndex(0);
              const chatTemp = {
                content: `최근 주문입니다. 다시하실 주문을 선택하세요.`,
                type: "bot",
                data: {
                  ordered: oRes.data.data.response,
                },
                state: "normal",
              };
              setChatType("normal");
              // setIsPay(false);
              setChat(chatTemp);
            } else if (oRes.data.data.response_code === "staple") {
              setPlayIndex(0);
              const chatTemp = {
                content: `자주 주문한 메뉴입니다. 메뉴를 선택하세요.`,
                type: "bot",
                data: {
                  ordered: oRes.data.data.response,
                },
                state: "normal",
              };
              setChatType("normal");
              // setIsPay(false);
              setChat(chatTemp);
            } else {
              const chatTemp = {
                content: `질문을 이해하지 못했어요`,
                type: "bot",
                data: null,
                state: "chat",
              };
              setChatType("chat");
              setChat(chatTemp);
            }
          } else {
            const chatTemp = {
              content: `정보를 찾지 못했어요`,
              type: "bot",
              data: null,
              state: "chat",
            };
            setChatType("chat");
            setChat(chatTemp);
          }
        }
        setIsLoading(false);
      }
    } catch (err) {
      console.log("err---->", err);
      setIsLoading(false);
    }
  };

  const filterChatData = () => {
    if (chat !== null && chat.data !== null) {
      setChatData(chat.data);
    }
  };

  const getResponseChat = () => {
    if (chat !== null && chat.type === "user") {
      // console.log("getResponseChat", chat, chatType);
      if (chat !== null && chatType !== "normal") {
        console.log("chat111", chat, chatType, chatData);
        getAIResponse();
      } else if (/*!isPay &&*/ chatData !== null) {
        console.log("chat222", chat, chatType, chatData);
        const filteredData = searchSimilarData(chat, chatData);
        console.log("filter", filteredData, chatData);
        if (filteredData === null) {
          setChat({
            content: `다시 말씀해주세요`,
            type: "bot",
            data: null,
            state: "chat",
          });
        } else {
          if (chatData.store_list) {
            setSelectedStore(filteredData);
          } else if (chatData.menu_list) {
            addCartData(filteredData);
          } else if (chatData.ordered) {
            addReorderData(filteredData);
          }
          setChatData(null);
        }
      }
    }
  };

  const closeChat = () => {
    if (chat !== null && chat.state === "confirm") {
      setIsChat(false);
    }
  };

  const addReorderData = async (order: CurrentOrderType) => {
    const reorder_data: orderDetailRealmType[] = [];
    // setIsPay(true);

    order.aPrdData.map((product) => {
      const reorderItem: orderDetailRealmType = {
        store_id: order.oStoreData.store_id,
        product_id: product.prd_id,
        product_name: product.prd_name,
        product_org_price: Number(product.prd_org_price),
        product_quantity: product.amount!,
        product_total_amount: Number(product.prd_base_price),
        options: product.oSelectedOptions
          ? Object.values(product.oSelectedOptions)
          : [],
      };
      reorder_data.push(reorderItem);
    });
    await AsyncLocalStorage.setItem(
      "reorder",
      JSON.stringify({
        store_id: order.oStoreData.store_id,
        data: reorder_data,
      })
    );

    // const chatTemp = {
    //   content: `${order.sOrderName}을 결제하시겠습니까?`,
    //   type: "bot",
    //   data: null,
    //   state: "pay",
    // };
    // setChatType("pay");
    // setChat(chatTemp);

    navigate("/order/payment", { replace: true });
  };
  const addCartData = async (product: ProductType) => {
    console.log("product", product);

    const cartData: orderDetailRealmType = {
      store_id: product.store_id ? product.store_id : selectedStore!.store_id,
      product_id: product.prd_id,
      product_name: product.prd_name,
      product_org_price: Number(product.prd_org_price),
      product_quantity: 1,
      product_total_amount: Number(product.prd_base_price),
      options: [],
    };

    await AsyncLocalStorage.setItem(
      "cart",
      JSON.stringify({
        store_id: product.store_id ? product.store_id : selectedStore!.store_id,
        data: [cartData],
      })
    );

    // const chatTemp = {
    //   content: `${product.prd_name}을 결제하시겠습니까?`,
    //   type: "bot",
    //   data: null,
    //   state: "pay",
    // };
    // setChatType("pay");
    // setChat(chatTemp);

    navigate("/order/payment", { replace: true, state: { chat: true } });
  };

  // const receiveData = (event: any) => {
  //   const receivedData = event.data;
  //   if (receivedData.type === "confirm") {
  //     const chatTemp = {
  //       content: `주문을 완료했어요`,
  //       type: "bot",
  //       data: null,
  //       state: "payment",
  //     };
  //     setChatType("payment");
  //     setChat(chatTemp);
  //     navigate("/order/complete", {
  //       state: { orderData: receivedData.data },
  //       replace: true,
  //     });
  //   } else if (receivedData.type === "error") {
  //     const chatTemp = {
  //       content: "결제에 실패했어요",
  //       type: "bot",
  //       data: null,
  //       state: "confirm",
  //     };
  //     setChatType("confirm");
  //     setChat(chatTemp);
  //     setIsPay(false);
  //     setSelectedStore(null);
  //     setChatData(null);
  //   }
  // };

  useEffect(() => {
    if (!isLoading) {
      console.log("response AI");
      getResponseChat();
      filterChatData();
    }

    if (chat === null || chat.state === "init") {
      // setIsPay(false);
      setChatType("init");
      setSelectedStore(null);
      setChatData(null);
    }
  }, [chat]);

  useEffect(() => {
    if (selectedStore !== null) {
      setChatData(null);
      getStoreInfo();
    }
  }, [selectedStore]);

  useEffect(() => {
    setTimeout(() => {
      if (chat === null) {
        const chatTemp = {
          content: "무엇을 도와 드릴까요?",
          type: "bot",
          data: null,
          state: "init",
        };
        setChat(chatTemp);
      }
    }, 300);

    AsyncLocalStorage.removeItem("reorder");
    AsyncLocalStorage.removeItem("cart");
  }, []);

  const sendTestQuestion = () => {
    if (process.env.REACT_APP_ENV === "DEV" && recognizerMode) {
      setChat({
        content: getRandomChat(),
        type: "user",
        data: null,
        state: "chat",
      });
      setRecognizerMode(false);
    }
  };

  return (
    <Style>
      <div
        className="voiceWrapper"
        onClick={closeChat}
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/img/background.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {chat !== null && (
          <div className="voiceContent">
            <h1>
              {chat === null
                ? ""
                : chat.type === "user"
                ? `"${chat.content}"`
                : chat.content}
            </h1>
            {chat.data === null ? (
              <div style={{ marginBottom: "6%" }}>
                <h2>이렇게 말해보세요</h2>
                <h2 className="guide">
                  {`"이벤트 매장 알려줘"   "최근 주문 내역 알려줘"   "카페 추천해줘"   "많이 주문한거 알려줘"   "카페라떼 마시고 싶어"`}
                </h2>
              </div>
            ) : chat.data.store_list ? (
              <div className="listWrap">
                {chat.data.store_list.map(
                  (dataItem: any, dataIndex: number) => (
                    <div
                      className="listItem"
                      key={dataIndex}
                      onClick={() => setSelectedStore(dataItem)}
                    >
                      <img
                        src={
                          dataItem.url_path
                            ? dataItem.url_path
                            : `${process.env.PUBLIC_URL}/svg/ic_none_image.svg`
                        }
                        alt="dataItemImg"
                      />
                      <h2>{dataItem.store_name}</h2>
                      <h3>{dataItem.distance.toFixed(1)}km</h3>
                    </div>
                  )
                )}
              </div>
            ) : chat.data.menu_list ? (
              <div className="listWrap">
                {chat &&
                  chat.data.menu_list.map(
                    (dataItem: any, dataIndex: number) => (
                      <div
                        className="listItem"
                        key={dataIndex}
                        onClick={() => addCartData(dataItem)}
                      >
                        <img src={dataItem.url_path} alt="dataItemImg" />
                        {dataItem.store_name && (
                          <h2 className="store">{dataItem.store_name}</h2>
                        )}
                        <h2>{dataItem.prd_name}</h2>
                        <h3>
                          {Number(dataItem.prd_org_price).toLocaleString()}원
                        </h3>
                      </div>
                    )
                  )}
              </div>
            ) : (
              chat.data.ordered && (
                <div className="listWrap">
                  {chat &&
                    chat.data.ordered.map(
                      (dataItem: CurrentOrderType, dataIndex: number) => (
                        <div
                          className="listItem ordered"
                          key={dataIndex}
                          onClick={() => addReorderData(dataItem)}
                        >
                          <div>
                            <h1>{dataItem.oStoreData.store_name}</h1>
                            <h3>{dataItem.oStoreData.distance.toFixed(1)}km</h3>
                          </div>
                          <h2>{dataItem.sOrderName}</h2>
                        </div>
                      )
                    )}
                </div>
              )
            )}
          </div>
        )}
        <div className={`imgWrap ${recognizerMode && "active"}`}>
          <img
            // onClick={sendTestQuestion}
            src={`${process.env.PUBLIC_URL}/img/speaking.gif`}
            alt="speaking"
            width="30%"
            height="100%"
          />
        </div>
        {/* </>
        )} */}
        {isLoading && <Spinner />}
      </div>
    </Style>
  );
};

export default VoiceChat;

const Style = styled.div`
  .voiceWrapper {
    width: 100%;
    min-height: 100vh;
    height: 100vh;
    z-index: 100;

    h1.test {
      position: absolute;
      color: red;
      top: 20px;
      left: 20px;
      z-index: 10000000;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    h1.test.data {
      top: 60px;
    }
  }

  .voiceContent {
    width: 100%;
    height: 75%;
    padding: 6% 10% 1% 10%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;

    h1 {
      font-size: 6vh;
      font-weight: 700;
      margin-bottom: 2%;
      color: #5b5ee7;
    }
    h2 {
      font-size: 4vh;
      line-height: 8vh;
      text-align: center;
      color: #ffffff;
    }
    h2.guide {
      font-size: 30px;
      font-weight: 500;
    }
  }
  .listWrap {
    margin: 0 auto;
    max-width: 100%;
    display: flex;
    overflow-x: auto;
    gap: 20px;
    .listItem {
      min-width: 35vh;
      max-width: 35vh;
      min-height: 35vh;
      padding-bottom: 8px;
      border-radius: 10px;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: left;
      img {
        width: 100%;
        height: 24vh;
        border-radius: 10px 10px 0 0;
        object-fit: fill;
        background: #000000;
      }
      h1,
      h2,
      h3 {
        padding: 0 20px;
        word-break: keep-all;
      }
      h2.store {
        height: 5vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #000000;
        font-weight: 600;
      }
      h2 {
        padding-top: 6px;
        font-size: 3vh;
        line-height: 3.5vh;
        color: #333333;
        text-align: left;
        font-weight: 500;
      }
      h3 {
        font-size: 2.5vh;
        line-height: 4vh;
        color: #a7a7a7;
        font-weight: 400;
      }
    }
    .listItem.ordered {
      min-height: 30vh;
      justify-content: center;
      gap: 30px;
      h1 {
        font-size: 3.5vh;
        font-weight: 600;
        color: #333333;
      }
    }
  }

  .imgWrap {
    width: 100%;
    position: fixed;
    bottom: 7%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    display: flex;
    justify-content: center;
    z-index: 10;
  }
  .imgWrap.active {
    opacity: 1;
  }
`;
